/* pb3.js - pull-up bar landing page behaviours (vanilla, deferred). */

/* ===== hero ===== */
/* ===== base:pb3-base ===== */
/* PB3 base: variant bus (window.PB3.onVariant replays ew2.js's ew:variant),
 * smooth scroll to the buy box, Okendo tab-stop guard for the cross-sell
 * tiles, focus management for the shared UGC video dialog. Idempotent;
 * re-seeds on shopify:section:load. */
(function () {
  'use strict';
  if (!document.body || !document.body.classList.contains('pb3') || window.PB3) return;
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var last = null, subs = [];

  function normalise(d) {
    if (!d) return null;
    var price = +d.price || 0;
    var was = d.compare_at != null ? +d.compare_at : (d.was != null ? +d.was : null);
    return {
      id: d.id != null ? String(d.id) : '',
      price: price,
      compare_at: was && was > price ? was : null,
      bundle: d.bundle || '',
      title: d.bundle || d.title || '',
      available: d.available !== false
    };
  }
  function publish(d) {
    last = d;
    for (var i = 0; i < subs.length; i++) {
      try { subs[i](d); } catch (e) { if (window.console) console.error(e); }
    }
    /* "Bundles: <kit>" legend in the hero picker. */
    var sel = document.querySelector('[data-pb3-picker-sel]');
    if (sel) sel.textContent = d.title;
  }
  /* ew2.js runs after this file, but the theme editor can reload a section
     after it rendered: rebuild the state from its global or the variant JSON. */
  function seed() {
    last = null;
    var d = normalise(window.EW_VARIANT);
    if (!d) {
      var input = document.getElementById('ewVariantId');
      var json = document.querySelector('[data-ew-variants]');
      if (input && json) {
        try {
          var list = JSON.parse(json.textContent || '[]');
          for (var i = 0; i < list.length; i++) {
            if (String(list[i].id) === input.value) { d = normalise(list[i]); break; }
          }
        } catch (e) { d = null; }
      }
    }
    if (d) publish(d);
  }

  window.PB3 = {
    onVariant: function (fn) {
      if (typeof fn !== 'function') return function () {};
      subs.push(fn);
      if (last) { try { fn(last); } catch (e) { if (window.console) console.error(e); } }
      return function () { subs = subs.filter(function (s) { return s !== fn; }); };
    },
    variant: function () { return last; }
  };
  document.addEventListener('ew:variant', function (e) {
    var d = normalise(e.detail);
    if (d) publish(d);
  });

  /* CTAs never leave the page (DM-2): smooth-scroll to the real product form. */
  document.addEventListener('click', function (e) {
    var t = e.target.closest && e.target.closest('[data-pb3-scroll], a[href="#ProductForm"], a[href="#buy"]');
    if (!t || t.hasAttribute('data-ew-submit')) return;
    var form = document.getElementById('ProductForm');
    if (!form) return;
    e.preventDefault();
    var h = document.querySelector('.shopify-section-header-sticky, sticky-header, #shopify-section-header');
    var top = form.getBoundingClientRect().top + window.pageYOffset - (h ? h.getBoundingClientRect().height : 0) - 24;
    window.scrollTo({ top: Math.max(0, top), behavior: reduced ? 'auto' : 'smooth' });
    var cta = document.getElementById('mainCta');
    if (cta) cta.focus({ preventScroll: true });
  });

  /* DM-3: Okendo's star widget inside cross-sell tiles makes itself focusable;
     each tile may expose a single tab stop beyond its button. */
  function okeGuard() {
    var wrap = document.querySelector('.xsell');
    if (!wrap) return;
    var fix = function () {
      wrap.querySelectorAll('.oke-is-clickable, [data-oke-star-rating] [tabindex]').forEach(function (el) {
        if (el.getAttribute('tabindex') !== '-1') el.setAttribute('tabindex', '-1');
        /* its click scrolls to this page's reviews, not the tile product's: no button role */
        if (el.classList.contains('oke-is-clickable') && el.hasAttribute('role')) el.removeAttribute('role');
      });
    };
    fix();
    if (!wrap.__pb3Oke) {
      var queued = false;
      wrap.__pb3Oke = new MutationObserver(function () {
        if (queued) return;
        queued = true;
        requestAnimationFrame(function () { queued = false; fix(); });
      });
      wrap.__pb3Oke.observe(wrap, { childList: true, subtree: true });
    }
  }

  /* Shared dm-ugc-carousel (key trusted_ugc): its fullscreen player is a
     role=dialog that never receives focus and has no accessible name. Name it,
     move focus to Close when it opens, keep Tab inside it, and hand focus back
     to the slide that opened it. The observer only reads the modal's class
     attribute and never writes to it, so it cannot re-trigger itself. */
  function ugcDialog() {
    document.querySelectorAll('.dm-ugc-section[id$="trusted-ugc"] .dm-ugc-modal').forEach(function (modal) {
      if (modal.__pb3) return;
      modal.__pb3 = true;
      var opener = null;
      var section = modal.closest('.dm-ugc-section');
      if (!modal.hasAttribute('aria-label')) modal.setAttribute('aria-label', 'Customer video');
      /* The infinite loop clones every card twice: keep the clones clickable but out of
         the tab order and the accessibility tree (8 "Play video" stops instead of 24). */
      if (section) section.querySelectorAll('[data-clone]').forEach(function (c) {
        c.setAttribute('aria-hidden', 'true');
        c.querySelectorAll('[tabindex], a[href], button').forEach(function (el) { el.setAttribute('tabindex', '-1'); });
      });
      function remember(e) {
        var t = e.target && e.target.closest ? e.target.closest('.dm-ugc__slide') : null;
        if (t) opener = t;
      }
      if (section) {
        section.addEventListener('pointerdown', remember, true);
        section.addEventListener('keydown', remember, true);
      }
      /* The player's product card links to this same product's default page. On the LP
         close the player and go to the buy box instead (DM-2: the [data-pb3-scroll] click
         handler above scrolls and focuses the CTA); other products still navigate. */
      var card = modal.querySelector('.dm-ugc-modal__product-card');
      if (card) card.addEventListener('click', function () {
        var same = !!card.pathname && card.pathname.replace(/\/$/, '') === location.pathname.replace(/\/$/, '');
        card.toggleAttribute('data-pb3-scroll', same);
        if (!same) return;
        opener = null;
        var x = modal.querySelector('.dm-ugc-modal__close');
        if (x) x.click();
      });
      function focusables() {
        return Array.prototype.filter.call(modal.querySelectorAll('button, a[href], [tabindex]:not([tabindex="-1"])'), function (el) {
          return !el.hidden && !el.closest('[hidden]') && el.getClientRects().length;
        });
      }
      modal.addEventListener('keydown', function (e) {
        if (e.key !== 'Tab') return;
        var f = focusables();
        if (!f.length) return;
        var first = f[0], last = f[f.length - 1], cur = document.activeElement;
        if (e.shiftKey && (cur === first || !modal.contains(cur))) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && (cur === last || !modal.contains(cur))) { e.preventDefault(); first.focus(); }
      });
      var wasOpen = modal.classList.contains('is-open');
      new MutationObserver(function () {
        var open = modal.classList.contains('is-open');
        if (open === wasOpen) return;
        wasOpen = open;
        if (open) {
          var close = modal.querySelector('.dm-ugc-modal__close');
          if (close) close.focus();
        } else if (opener && document.contains(opener)) {
          opener.focus({ preventScroll: true });
        }
      }).observe(modal, { attributes: true, attributeFilter: ['class'] });
    });
  }

  seed();
  okeGuard();
  ugcDialog();
  document.addEventListener('shopify:section:load', function () { seed(); okeGuard(); ugcDialog(); });
})();

/* ===== ext:ew-hero-buybox ===== */
/* Hero: round "next" arrow steps the gallery; quick-answer <details> become a
 * tablist (progressive enhancement: with no JS the ew2 accordion stays). */
(function () {
  'use strict';
  if (!document.body || !document.body.classList.contains('pb3')) return;
  var seq = 0;

  function initGalleryNext() {
    document.querySelectorAll('[data-pb3-gnext], [data-pb3-gprev]').forEach(function (btn) {
      if (btn.__pb3) return;
      btn.__pb3 = true;
      var dir = btn.hasAttribute('data-pb3-gprev') ? -1 : 1;
      btn.addEventListener('click', function () {
        var gallery = btn.closest('[data-ew-gallery]');
        var thumbs = gallery ? gallery.querySelectorAll('[data-ew-gallery-thumbs] img') : [];
        if (!thumbs.length) return;
        var cur = -1;
        for (var i = 0; i < thumbs.length; i++) if (thumbs[i].classList.contains('sel')) cur = i;
        var k = cur + dir;
        if (k < 0 || k >= thumbs.length) return; /* no wrap-around: the end arrows are disabled */
        thumbs[k].click(); /* ew2.js's delegated handler swaps the main image, marks .sel and scrolls the rail */
        syncArrows(gallery);
      });
    });
    document.querySelectorAll('[data-ew-gallery]').forEach(syncArrows);
  }

  /* First image selected = previous arrow off; last = next arrow off (owner, 1 Oct). */
  function syncArrows(gallery) {
    if (!gallery) return;
    var thumbs = gallery.querySelectorAll('[data-ew-gallery-thumbs] img'), cur = -1;
    for (var i = 0; i < thumbs.length; i++) if (thumbs[i].classList.contains('sel')) cur = i;
    var prev = gallery.querySelector('[data-pb3-gprev]'), next = gallery.querySelector('[data-pb3-gnext]');
    if (prev) prev.disabled = cur <= 0;
    if (next) next.disabled = cur < 0 || cur >= thumbs.length - 1;
  }

  function initHeroTabs() {
    document.querySelectorAll('.ew-scope .herofaq').forEach(function (wrap) {
      if (wrap.__pb3) return;
      var details = Array.prototype.slice.call(wrap.querySelectorAll(':scope > details'));
      if (details.length < 2) return;
      wrap.__pb3 = true;
      var id = ++seq, tabs = [];
      var list = document.createElement('div');
      list.className = 'herofaq-tabs';
      list.setAttribute('role', 'tablist');

      function update() {
        var open = -1;
        details.forEach(function (d, k) { if (d.open && open < 0) open = k; });
        if (open < 0) { open = 0; details[0].open = true; }
        tabs.forEach(function (b, k) {
          b.setAttribute('aria-selected', k === open ? 'true' : 'false');
          b.tabIndex = k === open ? 0 : -1;
        });
      }
      function select(i, focus) {
        details.forEach(function (d, k) { d.open = k === i; });
        update();
        if (focus) tabs[i].focus();
      }

      details.forEach(function (d, i) {
        var sum = d.querySelector('summary');
        if (!sum) return;
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'herofaq-tab';
        btn.id = 'pb3-tab-' + id + '-' + i;
        btn.setAttribute('role', 'tab');
        btn.textContent = sum.textContent.trim();
        var panel = d.querySelector('.herofaq-rich, p');
        if (panel) {
          panel.id = panel.id || 'pb3-panel-' + id + '-' + i;
          panel.setAttribute('role', 'tabpanel');
          panel.setAttribute('aria-labelledby', btn.id);
          btn.setAttribute('aria-controls', panel.id);
        }
        btn.addEventListener('click', function () { select(i, false); });
        btn.addEventListener('keydown', function (e) {
          var n = tabs.length, k;
          if (e.key === 'ArrowRight' || e.key === 'ArrowDown') k = (i + 1) % n;
          else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') k = (i - 1 + n) % n;
          else if (e.key === 'Home') k = 0;
          else if (e.key === 'End') k = n - 1;
          else return;
          e.preventDefault();
          select(k, true);
        });
        d.addEventListener('toggle', update);
        tabs.push(btn);
        list.appendChild(btn);
      });

      wrap.insertBefore(list, details[0]);
      wrap.classList.add('is-tabs');
      update();
    });
  }

  /* Thumbs are <img>s with a delegated click handler in ew2.js and are rebuilt
     on every kit change, so give them (and keep giving them) a button role, a
     tab stop, a distinct name and the selected state; Enter/Space = click.
     The observer only watches class flips (.sel), never its own attributes. */
  function initThumbs() {
    document.querySelectorAll('.ew-scope [data-ew-gallery-thumbs]').forEach(function (rail) {
      var imgs = rail.querySelectorAll('img'), n = imgs.length;
      imgs.forEach(function (img, i) {
        var label = 'Show image ' + (i + 1) + ' of ' + n;
        if (img.getAttribute('role') !== 'button') img.setAttribute('role', 'button');
        if (!img.hasAttribute('tabindex')) img.tabIndex = 0;
        if (img.getAttribute('aria-label') !== label) img.setAttribute('aria-label', label);
        if (img.classList.contains('sel')) {
          if (img.getAttribute('aria-current') !== 'true') img.setAttribute('aria-current', 'true');
        } else if (img.hasAttribute('aria-current')) {
          img.removeAttribute('aria-current');
        }
      });
      if (rail.__pb3) return;
      rail.__pb3 = true;
      rail.addEventListener('keydown', function (e) {
        var t = e.target;
        if (!t || t.tagName !== 'IMG') return;
        if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') { e.preventDefault(); t.click(); }
      });
      var queued = false;
      new MutationObserver(function () {
        if (queued) return;
        queued = true;
        requestAnimationFrame(function () { queued = false; initThumbs(); syncArrows(rail.closest('[data-ew-gallery]')); });
      }).observe(rail, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });
    });
  }

  function init() { initGalleryNext(); initHeroTabs(); initThumbs(); }
  init();
  document.addEventListener('shopify:section:load', init);
})();

/* ===== video_band ===== */
/* ===== new:pb3-video-band ===== */
/* pb3-video-band: in-view autoplay for [data-pb3-vb] video. preload none -> metadata
   within 400px (displayed element only), play at >= 60% visible, pause at <= 15% or
   hidden tab. One pause/play toggle per band (WCAG 2.2.2): a user pause holds until
   the user presses play again. Reduced motion / data saver / no IO: poster stays,
   native controls, toggle stays hidden. */
(function () {
  'use strict';
  var START = 0.6, STOP = 0.15, near, io, vids = [], bands = [];
  function shown(v) { return v.getClientRects().length > 0; }
  function band(v) { return v.closest('[data-pb3-vb]'); }
  /* Belt and braces for the IntersectionObserver: an emulated/zoomed layout
     viewport can be far taller than the visible one, so also require the
     element to be within `margin` px of the real client box before fetching. */
  function nearView(el, margin) {
    var vh = document.documentElement.clientHeight || window.innerHeight, r = el.getBoundingClientRect();
    return r.bottom > -margin && r.top < vh + margin;
  }
  function current(b) { return [].filter.call(b.querySelectorAll('video'), shown)[0]; }
  function prime(v) { if (!v.dataset.pb3Primed) { v.dataset.pb3Primed = '1'; v.preload = 'metadata'; v.load(); } }
  function start(v, user) {
    if (!shown(v) || (!user && band(v).dataset.pb3Hold)) return;
    if (v.paused) { prime(v); var p = v.play(); if (p && p.catch) p.catch(function () {}); }
  }
  function stop(v) { if (!v.paused) v.pause(); }
  function sync(b) {
    var t = b.querySelector('[data-pb3-vb-toggle]'), v = current(b);
    if (!t) return;
    var paused = !v || v.paused;
    b.classList.toggle('is-paused', paused);
    t.setAttribute('aria-label', paused ? t.dataset.play : t.dataset.pause);
  }
  function toggle(b) {
    var v = current(b);
    if (!v) return;
    if (v.paused) { delete b.dataset.pb3Hold; start(v, true); }
    else { b.dataset.pb3Hold = '1'; stop(v); }
  }
  function observe(v) {
    if (!io) {
      near = new IntersectionObserver(function (es) {
        es.forEach(function (e) { if (e.isIntersecting && shown(e.target) && nearView(e.target, 400)) prime(e.target); });
      }, { rootMargin: '400px 0px' });
      io = new IntersectionObserver(function (es) {
        es.forEach(function (e) {
          var r = e.intersectionRatio;
          if (e.isIntersecting && r >= START && nearView(e.target, 80)) start(e.target);
          else if (!e.isIntersecting || r <= STOP) stop(e.target);
        });
      }, { threshold: [0, STOP, START, 1], rootMargin: '80px 0px' });
      /* Hidden tab: pause. Back on the tab: resume only the videos this pause
         stopped (a user pause, data-pb3-hold, still wins inside start()). */
      document.addEventListener('visibilitychange', function () {
        vids.forEach(function (v) {
          if (document.hidden) { v.__pb3Resume = !v.paused; stop(v); }
          else if (v.__pb3Resume) { v.__pb3Resume = false; start(v); }
        });
      });
      if (window.matchMedia) {
        var mq = window.matchMedia('(min-width: 768px)'), onmq = function () { bands.forEach(sync); };
        if (mq.addEventListener) mq.addEventListener('change', onmq); else if (mq.addListener) mq.addListener(onmq);
      }
    }
    vids.push(v);
    near.observe(v); io.observe(v);
  }
  function init() {
    var still = !('IntersectionObserver' in window) ||
      (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) ||
      (navigator.connection && navigator.connection.saveData);
    [].forEach.call(document.querySelectorAll('[data-pb3-vb]'), function (b) {
      if (b.dataset.pb3Vb) return;
      b.dataset.pb3Vb = '1';
      var videos = b.querySelectorAll('video');
      if (still) { [].forEach.call(videos, function (v) { v.controls = true; }); return; }
      [].forEach.call(videos, function (v) {
        v.muted = true;
        v.addEventListener('play', function () { sync(b); });
        v.addEventListener('pause', function () { sync(b); });
        observe(v);
      });
      var t = b.querySelector('[data-pb3-vb-toggle]');
      if (t) {
        t.addEventListener('click', function () { toggle(b); });
        bands.push(b);
        b.classList.add('pb3-vb--js');
        sync(b);
      }
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();

/* ===== exercises ===== */
/* ===== new:pb3-exercises ===== */
(function () {
  /* mobile carousel prev/next + pager; progressive (scroll-snap works without JS) */
  function init(root) {
    if (root.dataset.pb3Ex) return;
    var track = root.querySelector('.pb3-ex__grid');
    var prev = root.querySelector('[data-ex-prev]');
    var next = root.querySelector('[data-ex-next]');
    if (!track || !prev || !next) return;
    var cards = track.querySelectorAll('.pb3-ex__card');
    if (cards.length < 2) return;
    root.dataset.pb3Ex = '1';
    root.classList.add('pb3-ex--js');
    /* The row only scrolls below 769px: make it a keyboard tab stop there only
       (arrow keys scroll it; focus ring = .pb3-ex__grid:focus-visible). */
    var rowMq = matchMedia('(max-width: 768px)');
    var rowTab = function () { if (rowMq.matches) track.tabIndex = 0; else track.removeAttribute('tabindex'); };
    rowTab();
    if (rowMq.addEventListener) rowMq.addEventListener('change', rowTab); else if (rowMq.addListener) rowMq.addListener(rowTab);
    var dots = root.querySelectorAll('.pb3-ex__dot');
    var behavior = matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
    var cur = 0;
    function mark(i) {
      cur = i;
      for (var k = 0; k < dots.length; k++) dots[k].classList.toggle('is-on', k === i);
    }
    function go(i) {
      i = (i + cards.length) % cards.length;
      var c = cards[i];
      track.scrollTo({ left: c.offsetLeft - (track.clientWidth - c.offsetWidth) / 2, behavior: behavior });
      mark(i);
    }
    prev.addEventListener('click', function () { go(cur - 1); });
    next.addEventListener('click', function () { go(cur + 1); });
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.intersectionRatio >= 0.6) mark(Array.prototype.indexOf.call(cards, e.target));
        });
      }, { root: track, threshold: 0.6 });
      cards.forEach(function (c) { io.observe(c); });
    }
  }
  function all(scope) { (scope || document).querySelectorAll('.pb3-ex').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { all(); });
  else all();
  document.addEventListener('shopify:section:load', function (e) { all(e.target); });
})();

/* ===== benefits_strip ===== */
/* ===== new:pb3-icon-marquee ===== */
/* pb3-icon-marquee: pause the CSS marquee while the strip is out of view (.is-off)
   and wire the keyboard Pause/Play button (.is-paused; its label names the next action,
   so no aria-pressed) */
(function () {
  var io = null;
  function init() {
    var strips = [].slice.call(document.querySelectorAll('[data-pb3-im]')).filter(function (s) { return !s.dataset.pb3Im; });
    if (!strips.length) return;
    if ('IntersectionObserver' in window) {
      io = io || new IntersectionObserver(function (es) {
        es.forEach(function (e) { e.target.classList.toggle('is-off', !e.isIntersecting); });
      }, { rootMargin: '120px 0px' });
    }
    strips.forEach(function (s) {
      s.dataset.pb3Im = '1';
      if (io) io.observe(s);
      var btn = s.querySelector('[data-pb3-im-pause]');
      if (!btn) return;
      btn.addEventListener('click', function () {
        var paused = !s.classList.contains('is-paused');
        s.classList.toggle('is-paused', paused);
        btn.textContent = paused ? (btn.dataset.labelPlay || 'Play animation') : (btn.dataset.labelPause || 'Pause animation');
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();

/* ===== shape_choice ===== */
/* ===== ext:ew-benefits ===== */
/* pb3 tabs: ew-benefits mobile tabs (.ps--tabs) and any [data-pb3-tabs] root.
 * Roving tabindex, click / Arrow / Home / End, panels toggled via data-ps-hidden
 * (never the hidden attribute, so desktop CSS keeps every card). Idempotent via
 * data-ps-ready; re-inits on shopify:section:load; shopify:block:select reveals
 * the selected card's tab in the theme editor. Event-driven only: no timers. */
(function () {
  'use strict';
  var ROOT_SEL = '.ps--tabs, [data-pb3-tabs]';
  var TAB_SEL = '[role="tab"]';

  function panelFor(tab) {
    var id = tab.getAttribute('aria-controls');
    return id ? document.getElementById(id) : null;
  }

  function initTabs(root) {
    if (!root || root.hasAttribute('data-ps-ready')) return;
    var tabs = Array.prototype.slice.call(root.querySelectorAll(TAB_SEL));
    if (!tabs.length) return;
    root.setAttribute('data-ps-ready', '');
    root.classList.add('is-ready');

    function select(tab, focus) {
      tabs.forEach(function (t) {
        var on = t === tab;
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        t.setAttribute('tabindex', on ? '0' : '-1');
        var p = panelFor(t);
        if (p) {
          if (on) p.removeAttribute('data-ps-hidden');
          else p.setAttribute('data-ps-hidden', '');
        }
      });
      if (focus) tab.focus();
    }

    root.addEventListener('click', function (e) {
      var tab = e.target.closest(TAB_SEL);
      if (tab && tabs.indexOf(tab) > -1) select(tab, false);
    });

    root.addEventListener('keydown', function (e) {
      var tab = e.target.closest(TAB_SEL);
      if (!tab || tabs.indexOf(tab) < 0) return;
      var i = tabs.indexOf(tab), n;
      switch (e.key) {
        case 'ArrowRight': case 'ArrowDown': n = (i + 1) % tabs.length; break;
        case 'ArrowLeft': case 'ArrowUp': n = (i - 1 + tabs.length) % tabs.length; break;
        case 'Home': n = 0; break;
        case 'End': n = tabs.length - 1; break;
        default: return;
      }
      e.preventDefault();
      select(tabs[n], true);
    });

    root.pb3Select = function (panel) {
      var tab = tabs.filter(function (t) { return panelFor(t) === panel; })[0];
      if (tab) select(tab, false);
    };

    var initial = tabs.filter(function (t) { return t.getAttribute('aria-selected') === 'true'; })[0] || tabs[0];
    select(initial, false);
  }

  function initAll(scope) {
    var ctx = scope && scope.querySelectorAll ? scope : document;
    Array.prototype.forEach.call(ctx.querySelectorAll(ROOT_SEL), initTabs);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  document.addEventListener('shopify:block:select', function (e) {
    var panel = e.target && e.target.closest ? e.target.closest('[role="tabpanel"]') : null;
    var root = panel && panel.closest(ROOT_SEL);
    if (root && root.pb3Select) root.pb3Select(panel);
  });
})();

/* ===== expect ===== */
/* ===== new:pb3-expect-tabs ===== */
/* pb3-expect-tabs (.pxt): WAI-ARIA tabs + mobile scroll-snap sync. Idempotent; re-inits on shopify:section:load. */
(function () {
  var DESK = window.matchMedia('(min-width: 1024px)');
  var REDUCE = window.matchMedia('(prefers-reduced-motion: reduce)');

  function initExpect(root) {
    if (root.dataset.pxtReady) return;
    var tabs = Array.prototype.slice.call(root.querySelectorAll('.pxt__tab'));
    var cards = Array.prototype.slice.call(root.querySelectorAll('.pxt__card'));
    var track = root.querySelector('.pxt__track');
    if (!tabs.length || tabs.length !== cards.length || !track) return;
    root.dataset.pxtReady = '1';
    var lockUntil = 0;

    function activate(i, scroll) {
      tabs.forEach(function (t, j) {
        var on = j === i;
        t.classList.toggle('is-active', on);
        t.setAttribute('aria-selected', on);
        t.tabIndex = on ? 0 : -1;
        cards[j].classList.toggle('is-active', on);
        cards[j].tabIndex = on ? 0 : -1;
      });
      if (!scroll || DESK.matches) return;
      lockUntil = Date.now() + 800;
      var left = cards[i].getBoundingClientRect().left - track.getBoundingClientRect().left + track.scrollLeft
        - (parseFloat(getComputedStyle(track).paddingLeft) || 0);
      if (track.scrollTo) track.scrollTo({ left: left, behavior: REDUCE.matches ? 'auto' : 'smooth' });
      else track.scrollLeft = left;
    }

    tabs.forEach(function (t, i) {
      t.addEventListener('click', function () { activate(i, true); });
      t.addEventListener('keydown', function (e) {
        var n = { ArrowRight: (i + 1) % tabs.length, ArrowLeft: (i + tabs.length - 1) % tabs.length, Home: 0, End: tabs.length - 1 }[e.key];
        if (n === undefined) return;
        e.preventDefault();
        activate(n, true);
        tabs[n].focus();
      });
    });

    // Swiping the row below 1024px: the most visible card owns the tab. A batch
    // only lists the cards that crossed a threshold, so each card's last ratio
    // is kept and the best of ALL cards wins (from 768px 1.7 cards show: the
    // fully visible card must beat its 68% neighbour).
    if ('IntersectionObserver' in window) {
      var ratio = cards.map(function () { return 0; });
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          ratio[cards.indexOf(en.target)] = en.isIntersecting ? en.intersectionRatio : 0;
        });
        if (DESK.matches || Date.now() < lockUntil) return;
        var best = 0;
        for (var j = 1; j < ratio.length; j++) if (ratio[j] > ratio[best]) best = j;
        if (ratio[best] >= 0.6) activate(best, false);
      }, { root: track, threshold: [0.6, 0.9, 1] });
      cards.forEach(function (c) { io.observe(c); });
    }

    // Crossing into desktop: show the card whose tab is selected.
    var onDesk = function () {
      if (!DESK.matches) return;
      var i = 0;
      tabs.forEach(function (t, j) { if (t.tabIndex === 0) i = j; });
      activate(i, false);
    };
    if (DESK.addEventListener) DESK.addEventListener('change', onDesk); else DESK.addListener(onDesk);
  }

  function initAll(scope) {
    Array.prototype.forEach.call((scope || document).querySelectorAll('.pxt'), initExpect);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(); });
  else initAll();

  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  document.addEventListener('shopify:block:select', function (e) {
    var card = e.target && e.target.closest && e.target.closest('.pxt__card');
    var tab = card && card.closest('.pxt').querySelector('.pxt__tab[aria-controls="' + card.id + '"]');
    if (tab) tab.click();
  });
})();

/* ===== offer_band ===== */
/* ===== new:pb3-offer-band ===== */
/* Offer band: pill = live saving of the hero's selected variant (PB3 variant bus,
   falls back to the raw ew:variant event); the marquee stops while off-screen
   (data-off -> animation: none in pb3.css) and restarts 200px before it scrolls back in. */
(function () {
  'use strict';
  if (window.__pb3OfferBand) return;
  window.__pb3OfferBand = true;

  /* Pause/Play button (WCAG 2.2.2): toggles .is-paused on its own band. */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-pb3-ob-pause]');
    var band = btn && btn.closest('[data-pb3-offer-band]');
    if (!band) return;
    var paused = !band.classList.contains('is-paused');
    band.classList.toggle('is-paused', paused);
    btn.textContent = paused ? 'Play animation' : 'Pause animation';
  });

  var io = ('IntersectionObserver' in window) && new IntersectionObserver(function (entries) {
    for (var i = 0; i < entries.length; i++) {
      if (entries[i].isIntersecting) entries[i].target.removeAttribute('data-off');
      else entries[i].target.setAttribute('data-off', '');
    }
  }, { rootMargin: '200px 0px' });

  function bands() { return document.querySelectorAll('[data-pb3-offer-band]'); }

  /* Same rounding as the hero's kit pills so band and picker never disagree. */
  function apply(v) {
    var list = bands();
    if (!v || !list.length) return;
    var ok = v.compare_at > v.price;
    var pct = ok ? Math.round((v.compare_at - v.price) / v.compare_at * 100) : 0;
    for (var i = 0; i < list.length; i++) {
      var b = list[i];
      b.hidden = !ok;
      if (!ok) continue;
      var text = (b.getAttribute('data-pill-format') || '[pct]% OFF').replace('[pct]', pct);
      var pills = b.querySelectorAll('[data-pb3-pct]');
      for (var j = 0; j < pills.length; j++) pills[j].textContent = text;
      var sr = b.querySelector('[data-pb3-sr]');
      if (sr) sr.textContent = (b.getAttribute('data-label') || '') + ': ' + text;
    }
  }

  function raw(d) {
    if (!d) return null;
    var price = +d.price || 0;
    var was = d.compare_at != null ? +d.compare_at : +d.was;
    return { price: price, compare_at: was > price ? was : null };
  }

  function watch() {
    if (!io) return;
    var list = bands();
    for (var i = 0; i < list.length; i++) io.observe(list[i]);
  }

  if (window.PB3 && PB3.onVariant) {
    PB3.onVariant(apply);
  } else {
    document.addEventListener('ew:variant', function (e) { apply(raw(e.detail)); });
    apply(raw(window.EW_VARIANT));
  }

  watch();
  document.addEventListener('shopify:section:load', function () {
    watch();
    apply(window.PB3 && PB3.variant ? PB3.variant() : raw(window.EW_VARIANT));
  });
})();

/* ===== features ===== */
/* ===== new:pb3-features ===== */
(function () {
  'use strict';
  /* pb3-features (.pubf): closes sibling items in browsers without <details name>
     and swaps the desktop photo panel to the open item. Idempotent; re-run on
     shopify:section:load. Hidden panel photos load on first show (data-src). */
  function show(pics, i) {
    pics.forEach(function (pic) {
      var on = pic.dataset.i === i;
      pic.hidden = !on;
      if (!on) return;
      var img = pic.querySelector('img[data-src]');
      if (!img) return;
      if (img.dataset.srcset) img.srcset = img.dataset.srcset;
      img.src = img.dataset.src;
      img.removeAttribute('data-src');
      img.removeAttribute('data-srcset');
    });
  }
  function init(root) {
    if (root.dataset.pubfReady) return;
    root.dataset.pubfReady = '1';
    var items = Array.prototype.slice.call(root.querySelectorAll('.pubf__item'));
    var pics = Array.prototype.slice.call(root.querySelectorAll('.pubf__pic'));
    items.forEach(function (d) {
      d.addEventListener('toggle', function () {
        if (!d.open) return; /* closing keeps the last photo so the panel never blanks */
        items.forEach(function (o) { if (o !== d && o.open) o.open = false; });
        show(pics, d.dataset.i);
      });
    });
    var open = root.querySelector('.pubf__item[open]') || items[0];
    if (open) show(pics, open.dataset.i);
  }
  function initAll(scope) {
    Array.prototype.forEach.call((scope || document).querySelectorAll('[data-pubf]'), init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(); });
  else initAll();
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  document.addEventListener('shopify:block:select', function (e) {
    var d = e.target && e.target.closest ? e.target.closest('.pubf__item') : null;
    if (d && !d.open) d.open = true;
  });
})();

/* ===== guarantee_contact ===== */
/* ===== new:pb3-guarantee-contact ===== */
/* pb3-guarantee-contact: live-chat pill fallback.
   The chat pill links to the Richpanel hash (#rp-customer-widget-home). If no Richpanel
   element is on the page the click goes to data-fallback (/pages/contact-us) instead.
   Delegated on document + flag-guarded, so it is idempotent and needs no re-binding
   on shopify:section:load (new section DOM is covered automatically). */
(function () {
  if (window.__pb3GcChatBound) return;
  window.__pb3GcChatBound = true;
  var WIDGET = '.richpanel-micro,#richpanel-widget,[class*="richpanel"],iframe[src*="richpanel"]';
  document.addEventListener('click', function (e) {
    var t = e.target;
    var a = t && t.closest ? t.closest('.pb3-gc [data-pb3-chat]') : null;
    if (!a) return;
    if (document.querySelector(WIDGET)) return; /* widget present: let the hash open it */
    e.preventDefault();
    window.location.assign(a.getAttribute('data-fallback') || '/pages/contact-us');
  });
})();

/* ===== crosssell ===== */
/* ===== ext:ew-crosssell ===== */
/* (cross-sell Okendo tab-stop guard: handled by okeGuard() in the base block) */
